import React, { useState } from "react";
import loadable from "@loadable/component";
import APIS from "../../contants/Endpoints";
import useGetHook from "../../customHooks/useGetHook";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useSearchParams } from "react-router-dom";
const HoldCartComponent = loadable(() => import("../../components/HoldCart"));
type Props = {};

const HoldCart = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const [holdOrderId, setHoldOrderId] = useState("");
  const [date, setDate] = useState("");

  const { data: holdOrderData, isPending: holdOrderLoading } = useGetHook({
    queryKey: [`hold-order-${pageSize}-${offset}-${searchQuery}-${date}`],
    url: `${APIS.ORDER}`,
    params: {
      payment_status: "hold",
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
      ...(date && { created__date: date }),
    },
  });
  const { data: singleHoldOrderData, isPending: singleHoldOrderLoading } =
    useGetHook({
      queryKey: [`hold-order${holdOrderId}`],
      url: `${APIS.ORDER}${holdOrderId}`,
      params: {
        payment_status: "hold",
      },
    });
  return (
    <HoldCartComponent
      holdOrderData={holdOrderData}
      holdOrderLoading={holdOrderLoading}
      singleHoldOrderData={singleHoldOrderData}
      setHoldOrderId={setHoldOrderId}
      setDate={setDate}
      pageSize={pageSize}
      setPageSize={setPageSize}
      offset={offset}
      setOffset={setOffset}
    />
  );
};

export default HoldCart;
